export default __webpack_public_path__ + "static/media/three.e9f57596.png";